module.exports = __webpack_public_path__ + "static/media/band-ad.8e14a94a.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/band-ad.jpeg
// module id = 202
// module chunks = 0